module.exports = __webpack_public_path__ + "static/paul-8774c11da7e208d24c8b43d359b5c801.png";